import { render } from "./AppBrandLogo.vue?vue&type=template&id=1f6cef08&scoped=true"
const script = {}

import "./AppBrandLogo.vue?vue&type=style&index=0&id=1f6cef08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6cef08"]])

export default __exports__